export const EXPERIMENT_CHECKOUT_INITIAL_AMOUNT = "e1";
export const EXPERIMENT_CHECKOUT_INITIAL_AMOUNT_UNDEFINED = 1;
export const EXPERIMENT_CHECKOUT_INITIAL_AMOUNT_FIVE = 2;